<template>
    <div class="home-page">
        <hp-slider :data="sliderData"/>
        <div class="home-page__section" v-if="data.news && data.news.length">
            <latest-news :data="data.news"/>
        </div>

        <hp-investors />

        <div class="home-page__section home-page__section--big container">
            <div class="row">
                <div class="col-default-6 col-tablet-12" v-if="data.events && data.events.length">
                    <hp-calendar :data="data.events" />
                </div>
                <div class="col-default-5 col-default-offset-1 col-tablet-offset-0 col-tablet-6 col-tablet-12">
                    <hp-reports :data="reportsData" />
                </div>
            </div>
        </div>

        <div class="home-page__section">
            <div class="container u-all-padding--no">
                <slot name="productions" />
            </div>
        </div>

        <div class="home-page__section container">
            <slot name="key-figures" />
        </div>

        <div class="home-page__section home-page__section--big container">
            <hp-sustainability :data="data.sustainability"/>
        </div>

        <div v-if="data.team && data.team.length" class="home-page__section">
            <hp-people :data="data.team"/>
        </div>

        <div class="home-page__section home-page__section--big container">
            <div class="row">
                <div class="col-default-3 col-tablet-12">
                    <z-caption
                        class="u-bottom-margin--m-important"
                        size="xl"
                        tag="h2"
                        uppercase
                        weight="900"
                    >
                        <span v-html="text.ourLife"></span>
                    </z-caption>
                    <z-button
                        tag="a"
                        :href="`/${$root.lang}/press-center/media-bank/`"
                        kind="text"
                        size="m"
                        >
                            <span v-html="text.mediaBank"></span>
                        <template v-slot:right>
                            <z-icon
                                name="arrow_long"
                                dir="right"
                                width="40"
                                height="24"
                            ></z-icon>
                        </template>
                    </z-button>
                </div>
                <div class="col-default-3 col-tablet-4 col-mobile-12">
                    <z-image src="/images/main-page/life-1.png" />
                </div>
                <div class="col-default-3 col-tablet-4 col-mobile-12">
                    <z-image src="/images/main-page/life-2.png" />
                </div>
                <div class="col-default-3 col-tablet-4 col-mobile-12">
                    <z-image src="/images/main-page/life-3.png" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import HpSlider from './components/Slider.vue'
import HpCalendar from './components/Calendar.vue'
import HpReports from './components/Reports.vue'
import HpSustainability from './components/Sustainability.vue'
import HpPeople from './components/People.vue'
import HpInvestors from './components/Investors.vue'

export default {
    name: 'home-page',
    components: {
        HpSlider,
        HpCalendar,
        HpReports,
        HpPeople,
        HpSustainability,
        HpInvestors
    },
    props: {
        sliderData: {
            type: Array,
            default: () => []
        },
        reportsData: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            data: this.$root.app.components['main-page'],
            text: {
                ourLife: localize({
                    ru: 'Наша <br class="hide-me--tablet">жизнь',
                    en: 'Our <br class="hide-me--tablet">life'
                }),
                mediaBank: localize({
                    ru: 'Медиаматериалы',
                    en: 'Media bank'
                })
            }
        }
    },
    methods: {
    }
}
</script>

<style lang="scss">
.home-page {
    &__section {
        @include padding-level(top, 2XL);
        @include padding-level(bottom, 2XL);

        @include breakpoint (mobile) {
            padding-top: $token-spacers-m;
            padding-bottom: $token-spacers-m;
        }

        &--big {
            @include padding-level(top, 3XL);
            @include padding-level(bottom, 3XL);

            @include breakpoint (mobile) {
                padding-top: $token-spacers-l;
                padding-bottom: $token-spacers-l;
            }
        }
    }

    .laptop-vertical-offset {
        @include breakpoint (laptop) {
            margin-top: -220px !important;
        }
        @include breakpoint (tablet) {
            margin-top: 0 !important;
        }
    }
}
</style>
